export default class ProcessDto {
  checkpointId: number;
}
